<script>
    import { onMount } from "svelte";
    import { slide, fade } from "svelte/transition";
    import { ModalSystem } from "./systems";

    let component = undefined;
    let props = undefined;
    let visitibility = false;
    let parameters = undefined;
    let size = undefined;

    const onChange = () => {
        component = ModalSystem.component;
        props = ModalSystem.props;
        visitibility = ModalSystem.visibility;
        parameters = ModalSystem.parameters;
        if (parameters && parameters.size) {
            size = parameters.size;
        }
    };

    onMount(() => {
        ModalSystem.onChange.subscribe(onChange);
    });
</script>

{#if visitibility}
    <div class="overlay" in:fade on:click={ModalSystem.hide}>
        <div
            in:slide
            class="modal {size ? size : ''}"
            on:click|stopPropagation={() => {}}
        >
            <svelte:component this={component} {...props} />
        </div>
    </div>
{/if}

<style>
    .overlay {
        position: fixed;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000bd;
        cursor: pointer;
        z-index: 300;
    }

    .modal {
        min-height: 100px;
        background: var(--color-level-1);
        /* padding: 10px; */
        justify-content: space-between;
        flex-shrink: 0;
        align-items: start;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        cursor: default;
        border-radius: 4px;

        /* Elevation Overlay / 24dp */
        box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.14),
            0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
    }

    .modal.small {
        width: 25%;
    }
</style>
